import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHybridAuth } from '../auth/HybridAuthContext';
import { Loader, Message } from 'semantic-ui-react';

export const SSOCallback = () => {
    const navigate = useNavigate();
    const { isAuthenticated, authError, clearAuthError } = useHybridAuth();
    const [error, setError] = useState<string | null>(null);    

    //console.log('SSOCallback - Component state:', { isAuthenticated, error });

    useEffect(() => {
        //      console.log('SSOCallback - useEffect triggered');

        // Check for OAuth errors in URL
        const urlParams = new URLSearchParams(window.location.search);
        const oauthError = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');
        //const code = urlParams.get('code');
        //const state = urlParams.get('state');

        // console.log('SSOCallback - URL params:', { 
        //   oauthError, 
        //   errorDescription, 
        //   hasCode: !!code, 
        //   hasState: !!state 
        // });

        if (oauthError) {
          //console.log('SSOCallback - OAuth error detected');      
          setError(`SSO Error: ${oauthError}. ${errorDescription || ''}`);
          return;
        }

        // Set a timeout in case authentication never completes
        const timeout = setTimeout(() => {
          if (!isAuthenticated && !authError) {
            setError('Authentication timed out. Please try again.');
          }
        }, 30000); // 30 second timeout

        return () => clearTimeout(timeout);
    }, [isAuthenticated, authError]);

    // Handle authentication errors from the context
    useEffect(() => {
      if (authError) {
        setError(authError);
      }
    }, [authError]); 
  
  
  
    // navigate when authenticated
    useEffect(() => {
      //console.log('SSOCallback - Navigation useEffect:', { isAuthenticated });
      if (isAuthenticated) {      
        console.log('SSO authentication completed, navigating...');
        const currentRoute = localStorage.getItem("route") || "Routed";
        navigate(`/${currentRoute}`);
      }
    }, [isAuthenticated, navigate]);


  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        padding: '20px'
      }}>
        <Message negative>
          <Message.Header>Authentication Failed</Message.Header>
          <p>{error}</p>
          <button 
            onClick={() => {
              // clear any store state
              clearAuthError();
              sessionStorage.removeItem('tenantConfig');
              navigate('/');
            }} 
            style={{ marginTop: '10px' }}
          >
            Return to Login
          </button>
        </Message>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column' 
    }}>
      <Loader active size="large">Processing SSO login...</Loader>
      <p style={{ marginTop: '20px' }}>Please wait while we complete your authentication.</p>
    </div>
  );
};